import { render, staticRenderFns } from "./profile.page.vue?vue&type=template&id=b6de4764&scoped=true&"
import script from "./profile.page.vue?vue&type=script&lang=ts&"
export * from "./profile.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6de4764",
  null
  
)

export default component.exports